import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'react-feather';

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/modal/dialog';

const ModalBox = ({
  open,
  onOpenChange,
  closeOnClick,
  contentStyle,
  children,
  triggerDisabled,
  triggerElement,
  headerText,
  headerIcon,
  hasHeader = true,
  type = 'default',
  usePortal = false,
}: {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  closeOnClick?: () => void;
  contentStyle?: string;
  children: React.ReactNode;
  triggerDisabled?: boolean;
  triggerElement?: React.ReactNode;
  triggerButtonAction?: () => void;
  headerText: string;
  headerIcon?: React.ReactNode;
  type?: string;
  usePortal?: boolean;
  hasHeader?: boolean;
}) => {
  const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (usePortal) {
      let portalDiv = document.getElementById('modal-portal');
      if (!portalDiv) {
        portalDiv = document.createElement('div');
        portalDiv.id = 'modal-portal';
        document.body.appendChild(portalDiv);
      }
      setPortalContainer(portalDiv);
    }
  }, [usePortal]);

  const modalContent = (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {triggerElement && <DialogTrigger asChild>{triggerElement}</DialogTrigger>}
      <DialogContent
        className={`${contentStyle?.includes('max-w-') ? contentStyle : 'max-w-[455px]'} `}
      >
        {hasHeader && (
          <DialogHeader>
            <div className='rounded-tl-xl rounded-tr-xl border-b border-border justify-between items-center inline-flex px-[20px] h-[67px]'>
              <div className='grow shrink basis-0 justify-start items-center gap-2 flex'>
                <div className='justify-end items-center flex'>
                  {headerIcon && (
                    <div className='text-text h-[22px] w-[22px] flex items-center'>
                      {headerIcon}
                    </div>
                  )}
                </div>
                <DialogTitle
                  className={`text-right text-text body-13-bold leading-normal ${
                    type === 'error' ? 'text-red-1' : ''
                  }`}
                >
                  {headerText}
                </DialogTitle>
              </div>
              <div className='flex hover:bg-hover rounded-md cursor-pointer' onClick={closeOnClick}>
                <DialogClose className='text-text focus-visible:outline-none p-1'>
                  <X className='text-text' size={24} strokeWidth={'1'} />
                </DialogClose>
              </div>
            </div>
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );

  if (usePortal && portalContainer) {
    return createPortal(modalContent, portalContainer);
  }

  return modalContent;
};

export default ModalBox;
